import React from "react";

const ProgressBar = (props) => {
  const { completed } = props;

  if (completed === 0) {
    return null;
  }

  return (
    <div className="progress-bar__container">
      <div className="progress-bar__container-filler" style={{ width: `${completed}%` }}>
        <span className="progress-bar__container-label">{`${completed}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
